<script>
    import { Router, navigateTo } from 'svelte-router-spa';
    import { routes } from './components/routes';

    import { onMount, onDestroy } from 'svelte';

    function onNavigateToEvent(event) {
        console.log(event);
        navigateTo(event.detail.name, (event.detail.lang ? event.detail.lang : null));
    }

    onMount(() => {
        document.addEventListener('navigateTo', onNavigateToEvent, {
            capture: true
        });
    });

    onDestroy(() => {
        document.removeEventListener('navigateTo', onNavigateToEvent, {
            capture: true
        });
    });

    const params = {};

    function routeLoaded(event) {
        document.dispatchEvent(new Event('hideMobileMenu'));
    }

</script>

<div class="app-wrap" >
    <Router {routes} {params} on:routeLoaded={routeLoaded}/>
</div>

<style>

</style>